export default __webpack_public_path__ + "assets/images/4c396223ac9d5ac6de5a718d5c77a1d1.jpg";